











import { Component, Vue } from "vue-property-decorator";
import gql from "graphql-tag";

import RoomList from "@/containers/RoomList.vue";
import SearchForm from "@/components/inputs/SearchForm.vue";
import SearchBuildingResult from "@/containers/SearchBuildingResult.vue";

interface Building {
  id: string;
  token: string;
  name: string;
  group: { name: string };
}

interface ApolloData {
  buildings: Building[];
}

@Component({
  components: {
    RoomList,
    SearchForm,
    SearchBuildingResult
  },
  apollo: {
    buildings: {
      query: gql`
        query {
          buildingFeed(count: 9999, page: 1) {
            buildings {
              id
              token
              name
              group {
                id
                name
              }
            }
          }
        }
      `,
      update(data) {
        return data.buildingFeed.buildings;
      }
    }
  }
})
export default class BuildingsList extends Vue implements ApolloData {
  selectMode = false;

  buildings = [];

  get loading(): boolean {
    return this.$apollo.loading;
  }

  search(token: string) {
    if (token) {
      this.$router.push({ name: "search-result", query: { q: token } });
    }
  }
}
